module.exports = __webpack_public_path__ + "static/img/ml.e264a626.svg";